
import React from 'react';
import Layout from '@/components/layout/Layout';
import MerchandiseStore from '@/components/merchandise/MerchandiseStore';

const Merchandise = () => {
  return (
    <Layout>
      <div className="container mx-auto p-4 pt-20">
        <h1 className="text-3xl font-bold mb-6">Merchandise</h1>
        <MerchandiseStore />
      </div>
    </Layout>
  );
};

export default Merchandise;
